module.exports = __webpack_public_path__ + "static/img/wq_phone.925808f.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/wq_phone.png
// module id = QquM
// module chunks = 0